import { message, Space } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ModalItem, ButtonItem } from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import apartadoPedidoPdf from "../../../../Pdf/apartadoPedidoPdf";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

// Vista previa del PDF de apartado de un pedido (complemento Empresa.pdfApartadoPedido).
// props: visible, pedidoId, apartadoAhora ([{ lineaId, cantidad }] de lo apartado en este
// movimiento), cerrar
class ModalApartadoPedidoPdf extends Component {
  state = { loading: false, pdf: null, folio: "" };

  componentDidMount() {
    if (this.props.visible && this.props.pedidoId) this.consultarTodo();
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible && this.props.pedidoId) {
      this.consultarTodo();
    }
  }

  consultarTodo() {
    this.setState({ loading: true });
    axios
      .post(
        "pedidos/datosApartadoPedidoPdf",
        {
          empresaId: this.props.empresaId,
          pedidoId: this.props.pedidoId,
          apartadoAhora: this.props.apartadoAhora || [],
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const pdf = pdfMake.createPdf(apartadoPedidoPdf(res.data));
          this.setState({ loading: false, pdf, folio: res.data.data.folio || "" }, () => {
            pdf.open({}, window.frames["apartadoPedidoPdf"]);
          });
        } else {
          this.setState({ loading: false });
          message.error(res.data.message || "No se pudieron cargar los datos del apartado");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("No se pudieron cargar los datos del apartado");
      });
  }

  descargar() {
    if (!this.state.pdf) return;
    this.state.pdf.download(`Apartado Pedido ${this.state.folio}`.trim() + ".pdf");
  }

  cerrarModal() {
    this.setState({ pdf: null, folio: "" });
    this.props.cerrar();
  }

  render() {
    return (
      <ModalItem
        title="Vista previa - Apartado del Pedido"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarModal.bind(this)}
        paddingTop
        width={window.innerWidth > 1000 ? "80%" : "95%"}
      >
        <div style={{ display: "flex", justifyContent: "right", marginBottom: 10 }}>
          <Space>
            <ButtonItem type="primary" disabled={!this.state.pdf} onClick={this.descargar.bind(this)}>
              Descargar
            </ButtonItem>
            <ButtonItem type="primary" danger onClick={this.cerrarModal.bind(this)}>
              Cerrar
            </ButtonItem>
          </Space>
        </div>
        <iframe
          title="apartadoPedidoPdf"
          style={{ width: "100%", height: "100vh" }}
          id="apartadoPedidoPdf"
          name="apartadoPedidoPdf"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalApartadoPedidoPdf);
